module.exports = __webpack_public_path__ + "static/media/toys.7637c55f.png";